export function openDirections(address: string): void {
  const destination = encodeURIComponent(address);
  const url = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
  if (typeof window !== "undefined") {
    window.open(url, "_blank");
  }
}
